import React, { useState } from 'react';

const PasswordField = ({
  label,
  value,
  onChange,
  required = false,
  readOnly = false,
  placeholder = '',
  style = {},
  inputStyle = {}
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const EyeIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="18" height="18">
      <path
        d="M12 5c5.5 0 9.7 4.3 11 7-1.3 2.7-5.5 7-11 7S2.3 14.7 1 12c1.3-2.7 5.5-7 11-7Zm0 2C8 7 4.6 9.9 3.3 12 4.6 14.1 8 17 12 17s7.4-2.9 8.7-5C19.4 9.9 16 7 12 7Zm0 1.5A3.5 3.5 0 1 1 12 16a3.5 3.5 0 0 1 0-7Zm0 2A1.5 1.5 0 1 0 12 13a1.5 1.5 0 0 0 0-3Z"
        fill="currentColor"
      />
    </svg>
  );

  const EyeOffIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="18" height="18">
      <path
        d="M2.1 3.5 20.5 21.9l-1.4 1.4-3-3c-1.2.4-2.6.7-4.1.7-5.5 0-9.7-4.3-11-7 1-2.1 3.5-5.4 7.2-6.7L.7 4.9 2.1 3.5Zm9.9 3c5.5 0 9.7 4.3 11 7-.6 1.3-1.8 3.1-3.7 4.8l-1.5-1.5c1.5-1.3 2.6-2.7 3.2-3.8C19.4 9.9 16 7 12 7c-.4 0-.8 0-1.2.1L9.2 5.5c.9-.2 1.8-.3 2.8-.3Zm0 3a3.5 3.5 0 0 1 3.5 3.5c0 .5-.1.9-.3 1.3l-4.5-4.5c.4-.2.8-.3 1.3-.3Zm-5.7 1.1 2 2c0 .1-.1.3-.1.4A3.5 3.5 0 0 0 12 16c.1 0 .3 0 .4-.1l2 2c-.8.3-1.5.5-2.4.5a5.5 5.5 0 0 1-5.5-5.5c0-.9.2-1.7.5-2.4Z"
        fill="currentColor"
      />
    </svg>
  );

  return (
    <div style={style}>
      {label && (
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        <input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          required={required}
          style={{
            width: '100%',
            padding: '0.75rem',
            paddingRight: '3rem',
            border: '1px solid #ddd',
            borderRadius: '6px',
            fontSize: '1rem',
            ...inputStyle
          }}
        />
        <button
          type="button"
          onClick={() => setShowPassword((current) => !current)}
          style={{
            position: 'absolute',
            right: '0.45rem',
            top: '50%',
            transform: 'translateY(-50%)',
            padding: '0.35rem',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            color: '#6c757d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          title={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;